import { render, staticRenderFns } from "./editObservationTemplate.vue?vue&type=template&id=1b68ea3d&v-if=loaded&"
import script from "./editObservationTemplate.vue?vue&type=script&lang=js&"
export * from "./editObservationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports